function a(s) {
  const e = {
    original: JSON.stringify(s),
    name: "UnknownError",
    message: "An unknown error occurred",
    isNetworkError: !1,
    isParseError: !1,
    details: ""
  }, n = {};
  if (s == null)
    return e.message = `Error value is ${s}`, e;
  if (typeof s != "object")
    return e.name = typeof s == "string" ? "StringError" : `${typeof s}Error`, e.message = String(s), e;
  try {
    if (s instanceof Error) {
      e.name = s.name || "Error", e.message = s.message || "An error occurred", e.stack = s.stack, (s instanceof SyntaxError || s instanceof TypeError) && (e.isParseError = !0);
      for (const t in s)
        t !== "name" && t !== "message" && t !== "stack" && (n[t] = s[t]);
    }
    typeof DOMException < "u" && s instanceof DOMException && (e.isNetworkError = !0, e.code = s.code, e.name = s.name, e.message = s.message), "name" in s && typeof s.name == "string" && (e.name = s.name), "message" in s && typeof s.message == "string" && (e.message = s.message), "code" in s && (e.code = s.code), "status" in s && typeof s.status == "number" && (e.status = s.status, e.isNetworkError = !0, "statusText" in s && (e.message = `${e.message} - ${s.statusText}`, n.statusText = s.statusText), "url" in s && (n.url = s.url)), (e.name === "NetworkError" || e.name === "AbortError" || e.message.includes("network") || e.message.includes("Network")) && (e.isNetworkError = !0), e.name === "SyntaxError" && e.message.includes("JSON") && (e.isParseError = !0);
    for (const t in s)
      if (t !== "name" && t !== "message" && t !== "stack" && t !== "status" && t !== "statusText" && t !== "url" && t !== "code")
        try {
          n[t] = s[t];
        } catch {
        }
  } catch (t) {
    n.parserError = String(t);
  }
  return { ...e, details: JSON.stringify(n) };
}
export {
  a as parseError
};
//# sourceMappingURL=contact-channels81.js.map
